import request from './api'

interface IVideoUrlsResponse {
    generateSignedUrl: string
    markForProcessing: string
    stream: string
}

export class VideoUrls {

    urls: IVideoUrlsResponse | null = null

    constructor() {
        if (!this.urls) {
            this.build().then((res) => {

            })
        }
    }

    async build() {
        const response = await request({
            method: 'GET',
            url: 'api/config/video-urls'
        });
        this.urls = response as unknown as IVideoUrlsResponse;
    }

    async GenerateSignedUrl() {
        if (!this.urls) {
            await this.build();
        }

        return this.urls?.generateSignedUrl;
    }

    async MarkForProcessing(videoId: string) {
        if (!this.urls) {
            await this.build();
        }

        return this.urls?.markForProcessing.replace(":videoId", videoId);
    }

    async Stream(videoId: string) {
        if (!this.urls) {
            await this.build();
        }

        return this.urls?.stream.replace(":videoId", videoId);
    }


    static get instance() {
        return videoUrls
    }
}

const videoUrls = new VideoUrls();
const rugbySportId = 2;

export class UploadService {

    async getVideoUploadApiUrl() {
        const response = await request({
            method: 'GET',
            url: 'api/config/video-upload-api-url',
        });

        return response;
    }

    async getSignedUrl(videoFileDetails: any) {
        const url = await videoUrls.GenerateSignedUrl();

        const response = await request({
            method: 'POST',
            url: url,
            data: {data: videoFileDetails, sportId: rugbySportId}
        });

        return response;
    }

    async markVideoForProcessing(videoId: string) {
        const url = await videoUrls.MarkForProcessing(videoId);

        const response = await request({
            method: 'POST',
            url: url,
            data: {}
        });

        return response;
    }

    async saveVideoUrl(fixtureId: string, videoId: string) {
        const response = await request({
            method: 'POST',
            url: `api/fixtures/${fixtureId}/video`,
            data: {
                videoUrl: videoId
            }
        });

        return response;
    }

    static get instance() {
        return uploadService
    }
}

const uploadService = new UploadService();

export default uploadService;